export default "__VITE_ASSET__CwlpokeU__"